export const preventForwardProps = (props: string[]) => {
  return {
    shouldForwardProp: (propName: PropertyKey) => !(props as PropertyKey[]).includes(propName),
  };
};
